var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.p)?_c('div',_vm._l((_vm.p.Announcements),function(announcement){return _c('div',{key:announcement,staticClass:"announcement-ribbon",domProps:{"innerHTML":_vm._s(announcement)},on:{"click":_vm.onGlobalNavigationClicked}})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }